import { faSave } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Result, Row, Space, Spin } from 'antd';
import { Route } from 'antd/lib/breadcrumb/Breadcrumb';
import * as React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import CustomPageHeader from '../../components/CustomPageHeader';
import { CSUserProfile } from '../../models/csuser-profile-interface';
import { CustomerServiceQueries } from '../../queries/customer-service-queries';
import { RoleQueries } from '../../queries/roles-query';
import EditUserCard from './components/EditUserCard';
import UserSelectionCard from './components/UserSelectionCard';

type routeParams = {
  id: string;
}

function ManageUserDetailPage() {
  const roleListQuery = RoleQueries.useRolesList();
  const allUsersQuery = CustomerServiceQueries.useUserList();
  const { id } = useParams<routeParams>();
  const formRef = React.useRef(null);
  const userDetail = CustomerServiceQueries.useUserDetail(parseInt(id, 10));
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  
  const routes: Route[] = [
    {
        path: "/admin/dashboard",
        breadcrumbName: 'Dashboard'
    },
    {
        path: "/admin/users/manage",
        breadcrumbName: "Manage Users"
    },
    {
      path: "",
      breadcrumbName: `${!!id ? "Edit" : "Create"} User`
    },
  ]

  const buttonsForHeader = [
    <Button
        id="SaveUser"
        type="primary"
        key="SaveUserButton"
        onClick={(e) => {
          e.preventDefault();
          formRef?.current.handleSubmit();
        }}
        loading={isSubmitting}
    ><Space>
      <FontAwesomeIcon icon={faSave}/>
        {`${!!id ? "Save" : "Create"} User`}
      </Space>
    </Button>  
]

  return (
    <Space direction='vertical' style={{width: '100%'}}>
      <CustomPageHeader
        routes={routes}
        title=""
        buttons={buttonsForHeader}
      />
      <Spin spinning={(!!id && userDetail.isLoading)}>
        <EditUserCard
          selectedUser={userDetail.data as CSUserProfile}
          roles={roleListQuery.data}
          formRef={formRef}
          setIsSubmitting={setIsSubmitting}
          allUsers={allUsersQuery.data}
        />
      </Spin>
    </Space>
  );
}

export default ManageUserDetailPage;
